var _style, _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "header-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1367 264.3",
    style: {
      enableBackground: "new 0 0 1367 264.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.8741,
    y1: 515.5451,
    x2: 172.9,
    y2: 515.5451,
    gradientTransform: "matrix(1365.98 0 0 -263.2483 -234776.0625 135848.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ABEB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ADED",
    offset: 100
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,0.5v241c95.4-2.9,143.7,20.2,239.3,22.8c143.9,3.9,160.8-40.6,372-44.9c69.5-1.4,148.1,22.2,286.1,22.2 c116.4,0,131-17.9,244.2-22.8c113.2-5,146.2,10,225,12.9s-0.5-231.2-0.5-231.2H0.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPrimary);
export default __webpack_public_path__ + "static/media/header-primary.bb36ecc3aa0ff12dfc13d37382e1f1b3.svg";
export { ForwardRef as ReactComponent };